import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../../api/useApi'

export const useTenantUserDefaults = () =>
  useQuery(['tenantUserDefaults'], async () => await apiClient.getHandlggareDefaults(localStorage.getItem('tenant_id') ?? '').then((res) => res.data), {
    refetchOnWindowFocus: false,
  })
